import http from '@/http';

export async function deleteHotpoint(id) {
  return await http.delete(`/admin/hotpoint-links/${id}`).then((res) => res.data);
}
